import {QUERY_KEYS} from '@/queryClient'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {
    httpGetTreatmentRequestsByPatient,
    HttpGetTreatmentRequestsByPatientOptions,
    HttpGetTreatmentRequestsByPatientResponse
} from '../services/treatment-requests.http'
import {PatientSmall} from '@/features/patients/types'

export const useGetInfiniteTreatmentRequestsByPatient = ({
    urlParams,
    params,
    options
}: {
    urlParams: {patientId: PatientSmall['id']}
    params: Omit<HttpGetTreatmentRequestsByPatientOptions['params'], 'page'>
    options?: Pick<UseInfiniteQueryOptions<HttpGetTreatmentRequestsByPatientResponse>, 'enabled'>
}) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.TREATMENT_REQUESTS, urlParams.patientId, params],
        queryFn: ({pageParam = 1}) =>
            httpGetTreatmentRequestsByPatient({
                urlParams,
                params: {
                    ...params,
                    page: pageParam
                }
            }),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    }
}
